import { useContext } from 'react';
import { VerificationRequestDialogContext } from '~/contexts/VerificationRequestDialogContext';

const useVerificationRequestDialog = () => {
  const props = useContext(VerificationRequestDialogContext);

  return props;
};

export default useVerificationRequestDialog;
